<template>
  <div class="mts-application-form">
    <template v-if="!formSubmissionResult">
      <h2
        v-if="formTitle"
        class="mts-application-form__title"
        v-html="formTitle"
      ></h2>

      <div
        v-if="formDescription"
        class="mts-application-form__description"
        v-html="formDescription"
      ></div>

      <form
        :id="formName"
        :name="formName"
        class="mts-application-form__form"
        @submit="formSubmit"
      >
        <input
          :id="`formId_${formName}`"
          type="hidden"
          name="formId"
          :value="formIdValue"
        />

        <input
          id="question"
          :value="formUserComment"
          type="hidden"
          name="question"
        />

        <input :id="`fio_${formName}`" type="hidden" name="fio" />
        <input :id="`google_cid_${formName}`" type="hidden" name="google_cid" />
        <input
          :id="`locale_${formName}`"
          type="hidden"
          name="locale"
          value="ru"
        />
        <input
          v-for="(value, name) in abTestHiddenFields"
          :key="name"
          :name="name"
          :value="value"
          type="hidden"
        />
        <div class="mts-application-form__form-fields">
          <div class="mts-application-form__field">
            <VInputMTS
              id="name"
              v-model="form.firstname"
              name="name"
              placeholder="Имя"
              autocomplete="name"
              type="text"
              :class="[
                formInputSize,
                {
                  error: getErrors('firstname') && $v.form['firstname'].$dirty,
                },
              ]"
              @focus="$v.form['firstname'].$reset()"
            />
            <VErrorMTS
              v-if="getErrors('firstname') && $v.form['firstname'].$dirty"
            >
              {{ getErrors('firstname') }}
            </VErrorMTS>
          </div>

          <div class="mts-application-form__field">
            <VInputMTS
              id="email"
              v-model="form.email"
              name="email"
              placeholder="Email"
              autocomplete="email"
              type="text"
              :class="[
                formInputSize,
                { error: getErrors('email') && $v.form['email'].$dirty },
              ]"
              @focus="$v.form['email'].$reset()"
            />
            <VErrorMTS v-if="getErrors('email') && $v.form['email'].$dirty">
              {{ getErrors('email') }}
            </VErrorMTS>
          </div>

          <div class="mts-application-form__field">
            <VPhoneInput
              @getValid="getValidPhone"
              :class="[
                formInputSize,
                getErrors('phone') && $v.form['phone'].$dirty ? 'error' : '',
              ]"
              :get-errors="getErrors('phone')"
            />
          </div>

          <slot
            name="inputs"
            :form-validation="$v.form"
            :get-errors="getErrors"
          ></slot>
        </div>

        <div id="captcha-container"></div>

        <slot name="btn" :is-loading="isLoading">
          <VButtonMTS
            type="submit"
            :is-loading="isLoading"
            class="mts-application-form__btn"
            :class="[formBtnColor, formBtnSize]"
          >
            {{ formBtnText }}
          </VButtonMTS>
        </slot>

        <VErrorMTS v-if="getErrors('token')" class="--captcha"
          >{{ getErrors('token') }}
        </VErrorMTS>

        <PolicyMessage
          v-if="formShowInfo"
          :button-text="formBtnText"
          :color-type="'--gray'"
          class="mts-application-form__info"
        />
      </form>
    </template>
    <MTSFormMessage
      v-if="formSubmissionResult"
      :type-message="statusFormText"
      :success="success"
      :message-for-success-application="messageForSuccessApplication"
    >
      <template #img>
        <img
          height="140"
          :src="
            require(`~/assets/img/partners/form-${
              success ? 'success' : 'fail'
            }.png`)
          "
          :width="140"
          alt="иконка"
        />
      </template>
    </MTSFormMessage>
  </div>
</template>

<script>
import SubmitGatewayMixin from '~/mixins/SubmitGatewayMixin'
import EventBus from '~/mixins/EventBus'
import ValidationFields from '~/mixins/ValidationFields'
import VInputMTS from '~/components/Common/MTS/VInputMTS'
import VErrorMTS from '~/components/Common/MTS/VErrorMTS'
import VButtonMTS from '~/components/Common/MTS/VButtonMTS'
import MTSFormMessage from '@/components/Common/Form/MTSFormMessage'
import VPhoneInput from '@/components/Feature/VPhoneInput.vue'
import ABTests from '@/helpers/ABTests'
import FormCaptchaMixin from '@/components/NewDesign/Form/mixins/FormCaptchaMixin'
import PolicyMessage from '@/components/NewDesign/Common/UI/PrivacyPolicy/PolicyMessage.vue'

export default {
  name: 'MTSApplicationUniversalForm',
  components: {
    PolicyMessage,
    VPhoneInput,
    MTSFormMessage,
    VInputMTS,
    VErrorMTS,
    VButtonMTS,
  },
  mixins: [ValidationFields, SubmitGatewayMixin, EventBus, FormCaptchaMixin],
  props: {
    formName: {
      type: String,
      default: '',
    },
    formUserComment: {
      type: String,
      default: '',
    },
    formTitle: {
      type: String,
      default: '',
    },
    formDescription: {
      type: String,
      default: '',
    },
    formIdValue: {
      type: String,
      default: '',
    },
    formInputSize: {
      type: String,
      default: '',
    },
    formBtnText: {
      type: String,
      default: 'Оставить заявку',
    },
    formBtnColor: {
      type: String,
      default: '--violet',
    },
    formBtnSize: {
      type: String,
      default: '--l',
    },
    formShowInfo: {
      type: Boolean,
      default: true,
    },
    messageForSuccessApplication: {
      type: String,
      default: '',
    },
    formFields: {
      type: Object,
      default: () => ({}),
    },
    isShowNumberDropdown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        firstname: '',
        email: '',
        phone: '',
        token: '',
      },
      abTestHiddenFields: null,
    }
  },
  computed: {
    formSubmissionResult() {
      return this.formName === this.idFormOnResult ? this.statusForm : false
    },
  },
  watch: {
    // после окнчания теста WR-1603 убрать эмит
    statusForm() {
      this.$emit('form-submit')
    },
    formFields: {
      handler(value) {
        this.form = {
          ...this.form,
          ...value,
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (
      this.$route.path.includes('products/messenger') &&
      this.formName !== 'products-messenger-demo'
    ) {
      this.abVariant = ABTests.getABFormSelectorVariant('ab_meetings_filter')
      this.abTestHiddenFields = ABTests.getABTestHiddenFields(
        'ab_meetings_filter',
        this.abVariant === '3' ? 'demo' : ''
      )
    }
  },
  methods: {
    getValidPhone(validPhone) {
      this.form.phone = validPhone
    },
  },
}
</script>

<style lang="scss" scoped>
.mts-application-form {
  &__title {
    font-family: $font-mts-compact;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    margin-bottom: 16px;
  }

  &__description {
    font-size: 17px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  &__form {
    display: flex;
    flex-direction: column;

    &-fields {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }
  }

  &__btn {
    color: $color-white;
    margin: 20px auto 0;
  }

  &__info {
    margin: 16px auto 0;
  }
}
</style>
